import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from '@yme/components/Link';
import { getRTL } from '@yme/selectors/common';
import { MegamenuListItemStyled, MegamenuListStyled, MegamenuStyled } from '../styled';
import { MenuItemWithSubMenu } from './MenuItemWithSubMenu';
export function ProductMenu({ navItems, driverLicenseLabel, closeMenuHandler, label, }) {
    const isRightToLeft = useSelector(getRTL);
    return (React.createElement(MegamenuStyled, { isRightToLeft: isRightToLeft, isProductMenu: true },
        React.createElement(MegamenuListStyled, { isRightToLeft: isRightToLeft }, navItems?.map((item) => {
            const { childPages, title, link, onClick } = item;
            return childPages.length ? (React.createElement(MenuItemWithSubMenu, { item: item, closeMenuHandler: closeMenuHandler, driverLicenseLabel: driverLicenseLabel, label: label })) : (React.createElement(MegamenuListItemStyled, { key: title, isRightToLeft: isRightToLeft, isLink: true },
                React.createElement("span", null,
                    React.createElement(Link, { to: link, onClick: () => onClick(link) }, title))));
        }))));
}
